import React from 'react';
import { InputAdornment } from '@material-ui/core';

export const bNumberPrefix = 'B22222';

export const formatBNumber = (bNumber?: string) => bNumber ? `${bNumberPrefix}${bNumber}` : '';

export const BNumberStartAdornment = <InputAdornment position="start">{bNumberPrefix}</InputAdornment>;
